export interface IEventEntity {
  id: string;
  ownerId: string;
  title: string;
  description?: string;
  location?: string;
  startDate?: number | string;
  endDate?: number | string;
  memoryId?: string;
  mediaIds?: string[];
  createdAt: number;
  updatedAt: number;
}

export interface ICreateEventRequest {
  title: string;
  description?: string;
  location?: string;
  startDate?: number | string;
  endDate?: number | string;
  memoryId?: string;
  mediaIds?: string[];
}

export interface ICreateEventResponse {
  status: boolean;
  event?: IEventEntity;
  eventId?: string;
  error?: string;
  timestamp: number;
}

export interface IEditEventRequest {
  id: string;
  title?: string;
  description?: string;
  location?: string;
  startDate?: number | string;
  endDate?: number | string;
  memoryId?: string;
  mediaIds?: string[];
}

export interface IEditEventResponse {
  status: boolean;
  event?: IEventEntity;
  error?: string;
  timestamp: number;
}

export interface IDeleteEventRequest {
  id: string;
}

export interface IDeleteEventResponse {
  status: boolean;
  error?: string;
  timestamp: number;
}

export interface IGetEventRequest {
  id: string;
}

export interface IGetEventResponse {
  status: boolean;
  event?: IEventEntity;
  error?: string;
  timestamp: number;
}

export interface IGetEventsRequest {
  limit?: number;
  memoryId?: string;
}

export interface IGetEventsResponse {
  status: boolean;
  events?: IEventEntity[];
  error?: string;
  timestamp: number;
}
